/**
 * Utilidades sobre la respuesta de /inventariosMateriales (ya trae apartado y
 * disponible por saldo).
 */
const idDe = (v) => (v && v._id ? v._id : v || "");

export const saldoDe = (existencias, r) =>
  existencias.find(
    (e) =>
      e.tipoMaterial === r.tipoMaterial &&
      idDe(e.material) === r.material &&
      (r.tipoMaterial === "Telas" ? idDe(e.colores) === (r.colores || "") : true)
  );

/** Limite = disponible (existencia menos lo apartado para pedidos). */
export const limiteDisponible = (existencias) => (r) => {
  if (r.tipoMaterial === "Telas" && !r.colores) return { maximo: Infinity, texto: "elige color" };
  const s = saldoDe(existencias, r);
  const disponible = s ? s.disponible ?? s.cantidad : 0;
  const texto = s && s.apartado > 0 ? `${disponible} (${s.apartado} apartado)` : `${disponible}`;
  return { maximo: disponible, texto };
};

/** Colores de una tela que tienen existencia en el almacen. */
export const coloresConExistencia = (existencias, colores) => (r) => {
  const ids = new Set(
    existencias
      .filter((e) => e.tipoMaterial === "Telas" && idDe(e.material) === r.material && e.cantidad > 0)
      .map((e) => idDe(e.colores))
  );
  return colores.filter((c) => ids.has(c._id));
};

/** Materiales de un tipo con existencia en el almacen. */
export const materialesConExistencia = (existencias, catalogo, tipo) => {
  const ids = new Set(existencias.filter((e) => e.tipoMaterial === tipo && e.cantidad > 0).map((e) => idDe(e.material)));
  return catalogo.filter((m) => ids.has(m._id));
};
